module.exports = __webpack_public_path__ + "static/img/wx-code.7fae4a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wx-code.png
// module id = C/0q
// module chunks = 130